export const SHOW_ROOM_DETAILS_EVENT = 'SHOW_ROOM_DETAILS_EVENT'